'use strict';

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

// Custom polyfill to replace jQuery's ability to add class to an array of elements
if (window.NodeList && !NodeList.prototype.addClass) {
    NodeList.prototype.addClass = function (cssClass) {
        this.forEach(function(item) {
            item.classList.add(cssClass);
        });
        return this;
    };
}

// Custom polyfill to replace jQuery's ability to remove class from an array of elements
if (window.NodeList && !NodeList.prototype.removeClass) {
    NodeList.prototype.removeClass = function (cssClass) {
        this.forEach(function(item) {
            item.classList.remove(cssClass);
        });
        return this;
    };
}

// Custom polyfill to replace jQuery's ability to set attribute to an array of elements
if (window.NodeList && !NodeList.prototype.setAttribute) {
    NodeList.prototype.setAttribute = function (attribute, value) {
        this.forEach(function(item) {
            item.setAttribute(attribute, value);
        });
        return this;
    };
}

// Custom polyfill to replace jQuery's ability to remove attribute from an array of elements
if (window.NodeList && !NodeList.prototype.removeAttribute) {
    NodeList.prototype.removeAttribute = function (attribute) {
        this.forEach(function(item) {
            item.removeAttribute(attribute);
        });
        return this;
    };
}

// Fullscreen API polyfill
if (!Element.prototype.requestFullscreen) {
    Element.prototype.requestFullscreen = Element.prototype.mozRequestFullscreen || Element.prototype.webkitRequestFullscreen || Element.prototype.msRequestFullscreen;
}

if (!document.exitFullscreen) {
    document.exitFullscreen = document.mozExitFullscreen || document.webkitExitFullscreen || document.msExitFullscreen;
}

// Fullscreen element properties
if (typeof document.fullscreenElement === 'undefined') {
    Object.defineProperty(document, 'fullscreenElement', {
        get: function() {
            return document.mozFullScreenElement || document.msFullscreenElement || document.webkitFullscreenElement || null;
        }
    });
}

if (typeof document.fullscreenEnabled === 'undefined') {
    Object.defineProperty(document, 'fullscreenEnabled', {
        get: function() { return document.mozFullScreenEnabled || document.msFullscreenEnabled || document.webkitFullscreenEnabled || false;
        }
    });
}

// Element.matches polyfill
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

// Element.closest polyfill
if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
        var el = this;
        do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}

// Object.assign polyfill
if (typeof Object.assign !== 'function') { // eslint-disable-line compat/compat
    Object.defineProperty(Object, "assign", {
        value: function assign(target) {
            if (target === null || target === undefined) {
                throw new TypeError('Cannot convert undefined or null to object');
            }

            var to = Object(target);

            for (var index = 1; index < arguments.length; index++) {
                var nextSource = arguments[index];

                if (nextSource !== null && nextSource !== undefined) {
                    for (var nextKey in nextSource) {
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
            return to;
        },
        writable: true,
        configurable: true
    });
}

// Number.isNaN polyfill (fixed typo)
if (!Number.isNaN) { // eslint-disable-line compat/compat
    Object.defineProperty(Number, 'isNaN', {
        value: function (value) {
            return value !== value;
        }
    });
}

// Array.prototype.findIndex polyfill
if (!Array.prototype.findIndex) {
    Object.defineProperty(Array.prototype, 'findIndex', {
        value: function (predicate) {
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);
            var len = parseInt(o.length) || 0;

            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }

            var thisArg = arguments[1];
            var k = 0;

            while (k < len) {
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return k;
                }
                k++;
            }

            return -1;
        },
        configurable: true,
        writable: true
    });
}

// Math.trunc polyfill
if (!Math.trunc) { // eslint-disable-line compat/compat
    Math.trunc = function (v) { // eslint-disable-line compat/compat
        return v < 0 ? Math.ceil(v) : Math.floor(v);
    };
}

// Math.sign polyfill
if (!Math.sign) { // eslint-disable-line compat/compat
    Math.sign = function (x) { // eslint-disable-line compat/compat
        return ((x > 0) - (x < 0)) || +x;
    };
}

// String.prototype.startsWith polyfill
if (!String.prototype.startsWith) {
    Object.defineProperty(String.prototype, 'startsWith', {
        value: function (search, rawPos) {
            var pos = rawPos > 0 ? rawPos | 0 : 0;
            return this.substring(pos, pos + search.length) === search;
        }
    });
}

// String.prototype.repeat polyfill
if (!String.prototype.repeat) {
    String.prototype.repeat = function (count) {
        if (this == null) {
            throw new TypeError('can\'t convert ' + this + ' to object');
        }

        var str = '' + this;
        count = +count;

        if (count !== count) { // Check for NaN
            count = 0;
        }

        if (count < 0) {
            throw new RangeError('repeat count must be non-negative');
        }

        if (count === Infinity) {
            throw new RangeError('repeat count must be less than infinity');
        }

        count = Math.floor(count);

        if (str.length === 0 || count === 0) {
            return '';
        }

        if (str.length * count >= 1 << 28) {
            throw new RangeError('repeat count must not overflow maximum string size');
        }

        var result = '';
        while (count > 0) {
            if (count % 2 === 1) {
                result += str;
            }
            if (count > 1) {
                str += str;
            }
            count = Math.floor(count / 2);
        }

        return result;
    };
}

// Object.is polyfill
if (!Object.is) { // eslint-disable-line compat/compat
    Object.is = function (x, y) { // eslint-disable-line compat/compat
        if (x === y) {
            return x !== 0 || 1 / x === 1 / y;
        } else {
            return x !== x && y !== y;
        }
    };
}

// ParentNode.prepend polyfill
(function (arr) {
    arr.forEach(function (item) {
        if (item.hasOwnProperty('prepend')) { // eslint-disable-line no-prototype-builtins
            return;
        }
        Object.defineProperty(item, 'prepend', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function prepend() {
                var argArr = Array.prototype.slice.call(arguments);
                var docFrag = document.createDocumentFragment();

                argArr.forEach(function (argItem) {
                    var isNode = argItem instanceof Node;
                    docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
                });

                this.insertBefore(docFrag, this.firstChild);
            }
        });
    });
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);
